import { DataModel } from 'legacy/lut/classes/models/DataModel'

import { IForm } from 'core-components/classes/models/IForm'

export const modifiedFieldsExt = [
  'CountryOfBusiness',
  'FirstName',
  'LastName',
  'MobilePhone',
  'MobilePhone_Prefix',
  'PreferredLanguage',
  'Salutation',
  'Seniority',
  'Status',
  'WorkPhone',
  'WorkPhone_Prefix',
  'Email',
  'NeverEmail',
  'NeverCall',
  'PR_HP_ROLE',
  'PrimaryPartner',
]

export interface IFormProfile extends IForm {
  EntryID?: number
  City?: string
  Competitors?: string
  Country?: string
  Email?: string
  FirstName?: string
  LastName?: string
  MobilePhone?: string
  MobilePhone_Prefix?: string
  Modified?: string
  ModifiedBy?: string
  NeverCall?: string
  NeverEmail?: string
  WorkPhone?: string
  WorkPhone_Prefix?: string
  AddressLine1?: string
  AddressLine2?: string
  AddressLine3?: string
  CommunicationName?: string
  ContactID?: string
  CountryOfBusiness?: string
  EmailCompany?: string
  Gender?: string
  HPPassportProfileID?: string
  HPHero?: number
  HPD_Contact_GUID?: string
  HPD_Partner_GUID?: string
  PR_HP_ROLE?: string
  PR_HP_ROLEExt?: string
  LastContactUpdateDate?: string
  LastPartnerUpdateDate?: string
  Last_Call_Date?: string
  LearnerID?: string
  LocationID?: string
  LoginID?: string
  MainPhone?: string
  OLD_ContactID?: string
  OLD_PartnerID?: string
  Organization?: string
  ParentPartnerID?: string
  PartnerID?: string
  Photo?: string
  PortalUserTypeCode?: string
  PreferredLanguage?: string
  PreferredContact?: number
  PrimaryJobRole?: string
  ProfessionalTitle?: string
  IsBusinessPartner?: string
  IsChampion?: string
  IsHero?: string
  IsPPA?: string
  IsSabaAdmin?: string
  IsSabaUser?: string
  Salutation?: string
  Seniority?: string
  Status?: string
  TaxID?: string
  URL?: string
  UserCreatedDate?: string
  UserLastLoginDate?: string
  UserRowID?: string
  UserStatus?: string
  ZIPCode?: string
  ProfileTeamComment?: string
  WorkflowStatus?: string | null
  ContactCodeStatus?: string | null
  ContactCodeModified?: string | null
  RelationshipStrength?: string
  ChangeMindset?: string
  Role?: string
  ContactStatus?: string
  ProfileAdditionalEntryId?: string
  LinkedInLink?: string
  FacebookLink?: string
  TwitterLink?: string
  WhatsAppLink?: string
  Registration?: any
  ProgramCodes?: any
  Completement?: number
  EntryIdAdd?: number
  Market?: string
  PrimaryPartner?: string
}

export const CreateExtByModel = (data: DataModel): IForm | null => {
  const form_data_table_375: IForm = {}

  form_data_table_375.EntryId = data.get('EntryIdExt') || data.get('EntryId') || ''
  form_data_table_375.CountryOfBusiness =
    data.get('CountryOfBusinessExt') || data.get('CountryOfBusiness') || ''
  form_data_table_375.Email = data.get('EmailExt') || data.get('Email') || ''
  form_data_table_375.FirstName = data.get('FirstNameExt') || data.get('FirstName') || ''
  form_data_table_375.LastName = data.get('LastNameExt') || data.get('LastName') || ''
  form_data_table_375.MobilePhone = (
    data.get('MobilePhoneExt') ||
    data.get('MobilePhone') ||
    ''
  ).replace(/[^0-9]+/gi, '')
  form_data_table_375.MobilePhone_Prefix = (
    data.get('MobilePhone_PrefixExt') ||
    data.get('MobilePhone_Prefix') ||
    ''
  ).replace(/[^0-9]+/gi, '')
  form_data_table_375.NeverCall = data.get('NeverCallExt') || data.get('NeverCall') || ''
  form_data_table_375.NeverEmail = data.get('NeverEmailExt') || data.get('NeverEmail') || ''
  form_data_table_375.NewPartnerID = data.get('NewPartnerIDExt') || data.get('NewPartnerID') || ''
  form_data_table_375.RelinkingComment =
    data.get('RelinkingCommentExt') || data.get('RelinkingComment') || ''
  form_data_table_375.PartnerID = data.get('PartnerIDExt') || data.get('PartnerID') || ''
  form_data_table_375.PR_HP_ROLE = data.get('PR_HP_ROLEExt') || data.get('PR_HP_ROLE') || ''
  form_data_table_375.PreferredLanguage =
    data.get('PreferredLanguageExt') || data.get('PreferredLanguage') || ''
  form_data_table_375.Salutation = data.get('SalutationExt') || data.get('Salutation') || ''
  form_data_table_375.Seniority = data.get('SeniorityExt') || data.get('Seniority') || ''
  form_data_table_375.Status = data.get('StatusExt') || data.get('Status') || ''
  form_data_table_375.WorkPhone = (data.get('WorkPhoneExt') || data.get('WorkPhone') || '').replace(
    /[^0-9]+/gi,
    ''
  )
  form_data_table_375.WorkPhone_Prefix = (
    data.get('WorkPhone_PrefixExt') ||
    data.get('WorkPhone_Prefix') ||
    ''
  ).replace(/[^0-9]+/gi, '')
  form_data_table_375.ModifiedValues = data.get('ModifiedValues') || ''
  form_data_table_375.ProfileTeamComment = data.get('ProfileTeamComment') || ''
  form_data_table_375.WorkflowStatus = data.get('WorkflowStatus') || ''
  form_data_table_375.ContactID = data.get('ContactIDExt') || data.get('ContactID') || ''
  form_data_table_375.PrimaryJobRole = data.get('PrimaryJobRoleExt') || ''
  form_data_table_375.Market = data.get('Market') || ''
  form_data_table_375.Source = data.get('Source') || ''
  form_data_table_375.InternalWorkflowStatus = data.get('InternalWorkflowStatus') || ''
  form_data_table_375.SourceRequestor = data.get('SourceRequestor') || ''

  const onboardingRequestId = data.get('OnboardingRequestId')
  if (onboardingRequestId) {
    form_data_table_375.OnboardingRequestId = onboardingRequestId
  }

  return form_data_table_375.ModifiedValues || form_data_table_375.ContactID.indexOf('new-') === 0
    ? form_data_table_375
    : null
}

export const CreateAdditionalByModel = (data: DataModel): IForm => {
  const form_data_table_379: IForm = {}

  form_data_table_379.EntryId = data.get('EntryIdAdd') || ''
  form_data_table_379.ChangeMindset = data.get('ChangeMindset') || ''
  form_data_table_379.Competitors = data.get('Competitors') || ''
  form_data_table_379.ContactStatus = data.get('ContactStatus') || ''
  form_data_table_379.FacebookLink = data.get('FacebookLink') || ''
  form_data_table_379.GDPR = data.get('GDPR') || ''
  form_data_table_379.HPChampion = data.get('HPChampion') || ''
  form_data_table_379.HPHero = data.get('HPHero') || ''
  form_data_table_379.LinkedInLink = data.get('LinkedInLink') || ''
  form_data_table_379.Photo = data.get('Photo') || ''
  form_data_table_379.PreferredContact = data.get('PreferredContact') || ''
  form_data_table_379.RelationshipStrength = data.get('RelationshipStrength') || ''
  form_data_table_379.Role = data.get('Role') || ''
  form_data_table_379.TwitterLink = data.get('TwitterLink') || ''
  form_data_table_379.WhatsAppLink = data.get('WhatsAppLink') || ''
  form_data_table_379.Modified = data.get('Modified') || ''
  form_data_table_379.ModifiedBy = data.get('ModifiedBy') || ''
  form_data_table_379.ContactID = data.get('ContactID') || ''
  form_data_table_379.PartnerID = data.get('PartnerID') || ''

  return form_data_table_379
}
